import React from "react";

function SvgComponent() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 14 14">
      <path
        fill="currentColor"
        d="M5.5 2.5V4H1.75v8.25H10V8.5h1.5V13a.75.75 0 01-.75.75H1A.75.75 0 01.25 13V3.25A.75.75 0 011 2.5h4.5zM13.75.25v6h-1.5V2.81L6.405 8.655l-1.06-1.06 5.844-5.845H7.75V.25h6z"
      ></path>
    </svg>
  );
}

export default SvgComponent;
